import { render, staticRenderFns } from "./affirm-modal.vue?vue&type=template&id=d4a1fc96&scoped=true&"
import script from "./affirm-modal.vue?vue&type=script&lang=js&"
export * from "./affirm-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a1fc96",
  null
  
)

export default component.exports